import { module } from 'modujs'
import { html } from '../utils/environment'
import config from '../config'
import SurveyMixin from '../utils/vue/mixins/SurveyMixin'
import { GtagHandler } from '../app'

export default class SurveyViolence extends module {
    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
    }

    init() {
        GtagHandler.emit('surveyStart')

        html.setAttribute('data-survey-violence-valid', 'false');

        const backUrl = this.$el.dataset.backUrl

        const moduleUrls = JSON.parse(this.$el.dataset.urls)
        const apiURL = moduleUrls.questions
        const resultsURL = moduleUrls.results

        const that = this

        this.app = new Vue({
            el: this.$el,
            mixins: [ SurveyMixin ],
            data: {
                apiURL
            },
            updated() {
                this.$nextTick(() => {
                    that.call('update', '#main', 'Scroll')
                })
            },
            computed: {
                lsqSrc() {
                    return this.currentQuestion?.a11yVideoQuestion?.fr
                },
            },
            methods: {
                onComplete() {
                    sessionStorage.setItem('surveyViolenceResults', JSON.stringify(this.questions))
                    html.setAttribute('data-survey-violence-valid', 'true')
                    that.call('goto', resultsURL, 'Load')
                },
                onBack() {
                    that.call('confirmTransition', backUrl, 'Load')
                },
                onBeforeSetCurrentQuestion() {
                    console.log('onBeforeSetCurrentQuestion')

                    return new Promise(resolve => {

                        if(!this.firstAnimation) {

                            gsap.to([this.supSplit, this.questionSplit], {
                                opacity: 0,
                                duration: 0.2,
                                ease: 'power2.out',
                                overwrite: true,
                                onComplete: () => {
                                    resolve()
                                }
                            })
                        } else {
                            resolve()
                        }
                    })
                },
                onSetCurrentQuestion() {
                    this.firstAnimation = false
                    console.log('onSetCurrentQuestion')

                    this.$nextTick(() => {
                        that.call('scrollTo', '#main', 'Scroll')

                        const supSplit = new SplitText(this.$refs.sup, {
                            type: 'words,chars'
                        })

                        this.supSplit = supSplit.chars

                        const questionSplit = new SplitText(this.$refs.question, {
                            type: 'words,chars'
                        })

                        this.questionSplit = questionSplit.chars

                        const tl = gsap.timeline({
                            defaults: {
                                ease: 'none'
                            }
                        })

                        tl
                            .fromTo(this.supSplit,
                                {
                                    opacity: 0
                                },
                                {
                                    duration: 0.3,
                                    opacity: 1,
                                    ease: 'none',
                                    stagger: 0.01,
                                },
                            0)
                            .fromTo(this.questionSplit,
                                {
                                    opacity: 0,
                                },
                                {
                                    opacity: 0.2,
                                    ease: 'sine.out',
                                    duration: 0.3
                                },
                            0)
                            .to(this.questionSplit, {
                                duration: 0.3,
                                opacity: 1,
                                ease: 'none',
                                stagger: 0.02,
                            }, '-=0.2')
                    })
                }
            },
        })

    }
    destroy() {
        this.app?.$destroy();
    }
}

